// components/global/ConfirmationDialog.vue
<template>
  <UModal v-model:open="dialogState.isOpen.value" @close="onModalClose"
    :title="dialogState.title.value"
    :description="dialogState.title.value"
    >

    <template #content>
    <UCard :ui="{ ring: 'ring-0', divide: 'divide-y divide-gray-100 dark:divide-gray-800' }">
      
      <template #header>
        <div class="flex items-center">
          <UIcon v-if="dialogState.icon.value" :name="dialogState.icon.value" class="mr-2 text-xl" />
          <h3 class="text-lg font-semibold">
            {{ dialogState.title.value }}
          </h3>
        </div>
      </template>

      <p class="text-sm text-gray-600 dark:text-gray-300">
        {{ dialogState.text.value }}
      </p>

      <template #footer>
        <div class="flex justify-end space-x-3">
          <UButton
            color="primary"
            variant="subtle"
            :label="dialogState.cancelButtonText.value"
            @click="dialogActions._handleCancel"
            :disabled="dialogState.isConfirming.value"
          />
          <UButton
            color="warning"
            :label="dialogState.confirmButtonText.value"
            @click="dialogActions._handleConfirm"
            :loading="dialogState.isConfirming.value"
          />
        </div>
      </template>
      
    </UCard>
    </template>
  </UModal>
</template>

<script setup lang="ts">
import { useConfirmationDialog } from '~/composables/useConfirmationDialog'

const {
  isOpen, // This is the readonly ref from the composable
  title,
  text,
  icon,
  confirmButtonText,
  cancelButtonText,
  isConfirming,
  _handleConfirm,
  _handleCancel
} = useConfirmationDialog()

// dialogState.isOpen is the readonly ref
const dialogState = { isOpen, title, text, icon, confirmButtonText, cancelButtonText, isConfirming }
const dialogActions = { _handleConfirm, _handleCancel }

// This function is crucial. It's called when UModal wants to close itself
// (e.g., user presses Esc, clicks overlay).
// It then calls our composable's method to update the actual state.
const onModalClose = () => {
  // Only act if the dialog was supposed to be open
  if (dialogState.isOpen.value) {
    console.log('ConfirmationDialog: onModalClose triggered, calling _handleCancel');
    dialogActions._handleCancel(); // This should set the composable's isOpen to false
  }
}
</script>